import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';

import styles from './Badge.module.css';

type BadgeTone = 'neutral' | 'info' | 'ok' | 'warn' | 'crit';
type BadgeSize = 'xs' | 'sm' | 'md';

export interface BadgeProps {
  tone?: BadgeTone;
  size?: BadgeSize;
  children: ReactNode;
}

/**
 * MCUI Badge — mirror from broadcast-frontend atoms.
 * Inline status label with semantic tones.
 */
export function Badge({ tone = 'neutral', size = 'sm', children }: BadgeProps) {
  const { t } = useTranslation([
    'common',
    'nav',
    'board',
    'articles',
    'analytics',
    'feeddrive',
    'config',
    'strategist',
  ]);
  return (
    <span className={`${styles.root} ${styles[`tone-${tone}`]} ${styles[`size-${size}`]}`}>
      {Boolean(t) && children}
    </span>
  );
}
